import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListCommentsBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List comments</div>
          <div className="text">
            Returns a list of comments. Include parameters to specify post, board,
            and&nbsp;pagination. Sorted by newest.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The id of the author you'd like to fetch comments for.",
                heading: 'authorID',
                subheading: 'string (optional)',
              },
              {
                description: "The id of the board you'd like to fetch comments for.",
                heading: 'boardID',
                subheading: 'string (optional)',
              },
              {
                heading: 'companyID',
                subheading: 'string (optional)',
                description:
                  'If specified, will only fetch posts created by users linked to the company with this custom identifier.',
              },
              {
                description:
                  "The number of comments you'd like to fetch. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description: "The id of the post you'd like to fetch comments for.",
                heading: 'postID',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of comments you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "comments" property that contains an array of comment objects.
            There's also a "hasMore" property that specifies whether this query returns more
            comments than the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/comments/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/comments/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d postID=553c3ef8b8cdcd1501ba2468`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "comments": [{
    "id": "553c3ef8b8cdcd1501ba1238",
    "author": {
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "${this.createdAt.toISOString()}",
      "email": "test@test.test",
      "isAdmin": false,
      "name": "Sally Doe",
      "url": "https://your-company.canny.io/admin/users/sally-doe",
      "userID": "1234"
    },
    "board": {
      "created": "${this.createdAt.toISOString()}",
      "id": "553c3ef8b8cdcd1501ba1234",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "created": "${this.createdAt.toISOString()}",
    "imageURLs": [
      "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
      "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
    ],
    "internal": false,
    "likeCount": 2,
    "mentions": [],
    "parentID": "553c3ef8b8cdcd1501ba3333",
    "post": {
      "category": {
        "id": "553c3ef8b8cdcd1501ba2234",
        "name": "Dashboard",
        "postCount": 42,
        "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
      },
      "commentCount": 2,
      "id": "553c3ef8b8cdcd1501ba4444",
      "imageURLs": [],
      "jira": {
        "linkedIssues": [{
          "id": "123",
          "key": "ID-123",
          "url": "https://your-company.atlassian.net/browse/ID-123"
        }]
      },
      "linear": {
        "linkedIssueIDs": ["ID-123", "ID-345"],
      },
      "score": 13,
      "status": "planned",
      "tags": [{
        "id": "553c3ef8b8cdcd1501ba3234",
        "name": "iOS",
        "postCount": 15,
        "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
      }],
      "title": "post-title",
      "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
    },
    "private": false,
    "reactions": {
      "like": 2
    },
    "value": "Some cool comment"
  }],
  "hasMore": false
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
